import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Ensures each new route lands the user at the top of the page instead of
 * inheriting the previous route's scroll position.
 *
 * Handles BOTH the window scroll AND any scrollable AppShell content region
 * (identified by data-scroll-region="main"), so nested layouts inside our
 * sidebar-fixed shell also snap to top.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // 1. window scroll (public pages, landing, etc.)
    try { window.scrollTo({ top: 0, left: 0, behavior: "auto" }); } catch { /* noop */ }

    // 2. any AppShell inner content region
    const regions = document.querySelectorAll('[data-scroll-region="main"]');
    regions.forEach((el) => {
      try { el.scrollTop = 0; el.scrollLeft = 0; } catch { /* noop */ }
    });
  }, [pathname]);

  return null;
}
